import { render, staticRenderFns } from "./ProductPricesTab.vue?vue&type=template&id=73ba391a"
import script from "./ProductPricesTab.vue?vue&type=script&lang=js"
export * from "./ProductPricesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports